import React from 'react'
import { Link, RouteComponentProps } from 'react-router-dom'

import EntityHeader from '../ui/entity/EntityHeader'
import EntityHeaderTitle from '../ui/entity/EntityHeaderTitle'
import Plus from '../icons/organizations/Plus'

import PromotionsTable from '../../containers/promotions/PromotionsTable'

import { IPromotion, ITripFilters } from '../../types'
import HorizontalSelector from '../HorizontalSelector'
import HorizontalSelectorItem from '../HorizontalSelectorItem'
import { boolean } from 'yup'
import PromotionsSearch from 'src/containers/promotions/PromotionsSearch'

interface IPromotionsProps extends RouteComponentProps {
  currentOrgId: string
  updatePromotionFilters: (params: ITripFilters) => Promise<any>
}

interface IPromotionState {
  isActive: boolean
}
export default class Promotions extends React.Component<IPromotionsProps, IPromotionState> {
  constructor(props: IPromotionsProps) {
    super(props)
    this.state = {
      isActive: true
    }
  }
  public componentDidMount() {
    const { currentOrgId } = this.props
    const filterPayload: ITripFilters = {}
    if (currentOrgId) {
      filterPayload.orgId = currentOrgId
      this.props.updatePromotionFilters(filterPayload)
    }
  }
  public render() {
    return (
      <div className='col-12'>
        <div className='flex mb2'>
          <div className='ml3 col-3'>
            <HorizontalSelector>
              <HorizontalSelectorItem isSelected={this.state.isActive}>
                <div className='uppercase cursor--pointer' onClick={() => this.setPromotions(true)}>
                  Promotions
                </div>
              </HorizontalSelectorItem>
              <HorizontalSelectorItem isSelected={!this.state.isActive}>
                <div className='uppercase cursor--pointer' onClick={() => this.setPromotions(false)}>
                  Archived Promotions
                </div>
              </HorizontalSelectorItem>
            </HorizontalSelector>
          </div>
        </div>
        <div className='bb-light-grey4'>
          <EntityHeader>
            <div className='flex ml-auto items-center'>
              <PromotionsSearch />
              {this.state.isActive && (
                <Link
                  to={`${this.props.match.path}/create`}
                  className='m1 cursor--pointer p1 bg-green rounded flex items-center'
                >
                  <Plus />
                  <span className='Title font-white fs-14 ml1'>Create Promotion</span>
                </Link>
              )}
            </div>
          </EntityHeader>
        </div>
        <PromotionsTable orgId={this.props.currentOrgId} isActive={this.state.isActive} />
      </div>
    )
  }
  private setPromotions(isActive: boolean) {
    this.setState({
      isActive
    })
  }
}



// WEBPACK FOOTER //
// ./src/components/promotions/Promotions.tsx